import React from "react";
import { Modal, Button } from "react-bootstrap";
import PuffLoader from "react-spinners/PuffLoader";

const ModalFooter = (props) => {
  return (
    <Modal.Footer>
      <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Button type="button" data-testid="delete-modal-no-button" variant="secondary" onClick={props.onHide}>
          Cancel
        </Button>

        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          {props.submitLoading ? (
            <PuffLoader size={40} color={"black"} loading={true} />
          ) : (
            <Button
              type="button"
              data-testid="delete-modal-delete-button"
              disabled={props.submitLoading}
              variant="primary"
              onClick={props.onSubmitClick}
            >
              {props.submitButtonText}
            </Button>
          )}
        </div>
      </div>
    </Modal.Footer>
  );
};

export default ModalFooter;
